import { motion } from "framer-motion";
import { Handshake, Users, TrendingUp, GraduationCap } from "lucide-react";
import LeadForm from "@/components/LeadForm";
import PayButton from "@/components/PayButton";
import CtaBand from "@/components/CtaBand";

const STEPS = [
  ["Who can join", "Service mindset, local relationships aur insurance/financial services mein interest — bas itna kaafi hai shuruat ke liye.", GraduationCap],
  ["Training & support", "Product orientation, practical guidance aur ek trusted team jo aapko confidently customers serve karna sikhayegi.", Users],
  ["Build your practice", "Referrals aur relationships se apna flexible, long-term advisory career banayein.", TrendingUp],
];

export default function Partner() {
  return (
    <>
      <section className="page-hero dark" data-testid="partner-hero">
        <div className="eyebrow gold">Partner / Agent Onboarding</div>
        <h1>Turn your network <span className="accent">into a career.</span></h1>
        <p>Bima Bachat Bazar ke partner network se judiye — 11 official platforms, training aur local brand support ke saath apna advisory business shuru karein.</p>
        <div className="hero-actions">
          <a href="#partner-apply" className="btn btn-light" data-testid="partner-apply-scroll"><Handshake size={16} /> Apply as a partner</a>
        </div>
      </section>
      <section className="section">
        <div className="section-head centered">
          <div className="eyebrow blue">Start with the right support</div>
          <h2>Teen steps, <span className="accent">ek nayi shuruaat.</span></h2>
        </div>
        <div className="pillar-grid three">
          {STEPS.map(([title, text, Icon], i) => (
            <motion.article className="pillar-card" key={title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} data-testid={`partner-step-${i}`}>
              <span className="chapter-no">0{i + 1}</span>
              <div className="service-icon gold"><Icon size={20} /></div>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </section>
      <section className="section section-light" id="partner-apply" data-testid="partner-apply-section">
        <div className="detail-grid">
          <div>
            <div className="eyebrow gold">Apply now</div>
            <h2>Partner enquiry <span className="accent">bhejein.</span></h2>
            <p>Form submit karte hi hamari team aapse WhatsApp par baat karegi — eligibility, training aur onboarding process ke baare mein.</p>
            <div className="pay-inline">
              <p><strong>Fast-track onboarding:</strong> onboarding fee online bhi pay kar sakte hain.</p>
              <PayButton serviceKey="partner-onboarding" label="Partner Onboarding" amount={999} />
            </div>
            <small className="disclaimer">Partner opportunities, commissions and earnings are subject to eligibility, performance, agreements and applicable regulations. Actual earnings may vary and are not guaranteed.</small>
          </div>
          <LeadForm preset={["Other Service"]} title="Partner / Agent Application" />
        </div>
      </section>
      <CtaBand compact />
    </>
  );
}
